import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LayoutMain from './shared/layout/LayoutMain';
import NotFound from './pages/NotFound';
import LayoutSetting from './shared/layout/LayoutSetting';
import { Provider } from 'react-redux';
import store, { persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';

import routersMain from './routers/RoutersMain';
import routersSub from './routers/RoutersSub';

import BlankPage from './pages/BlankPage';
import ForbiddenError from './pages/ForbiddenError';
import routersOther from './routers/RoutersOther';
import LayoutWithSidebar from './shared/layout/LayoutWithSidebar';
import routersWidthSidebar from './routers/RoutersWithSidebar';

const App = () => {
    return (
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <BrowserRouter>
                    <Routes>
                        {routersOther.map((item, index) => (
                            <Route key={index} path={item.path} element={<item.element />} />
                        ))}
                        <Route element={<LayoutWithSidebar />}>
                            {routersWidthSidebar.map((item, index) => (
                                <Route key={index} path={item.path} element={<item.element />} />
                            ))}
                        </Route>
                        <Route element={<LayoutMain />}>
                            {routersMain.map((item, index) => (
                                <Route key={index} path={item.path} element={<item.element />} />
                            ))}
                            <Route path="/BlankPage" element={<BlankPage />} />
                        </Route>
                        <Route element={<LayoutSetting />}>
                            {routersSub.map((item, index) => (
                                <Route key={index} path={item.path} element={<item.element />} />
                            ))}
                        </Route>
                        <Route path="/forbidden" element={<ForbiddenError />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    );
};

export default App;
